module.exports = __webpack_public_path__ + "img/twitter.c9f12008.svg";